export default __webpack_public_path__ + "static/media/logo-exatronic-white.adb92905.svg";